export default "__VITE_ASSET__G9mRN4PM__"